import { ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'
import { Link } from 'react-router'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export interface MobileListItemProps {
  title: string
  status?: ReactNode
  subtitle?: string
  /** `muted` pour une valeur absente (« Adresse non renseignée ») : elle ne
   *  doit pas peser autant qu'une vraie donnée. */
  subtitleTone?: 'default' | 'muted'
  meta?: readonly (string | undefined | false)[]
  warning?: string | false
  href: string
  /** État de navigation transmis à la page ouverte (adresse de retour, par exemple). */
  state?: unknown
  className?: string
}

/**
 * Carte de résultat Mobile (Sprint 003) : identité + statut en premier, 2-4 informations
 * essentielles maximum, jamais une table Desktop simplement réempilée.
 */
export function MobileListItem({
  title,
  status,
  subtitle,
  subtitleTone = 'default',
  meta,
  warning,
  href,
  state,
  className,
}: MobileListItemProps) {
  return (
    <Link className={mergeClassNames('ds-mobile-list-item', className)} to={href} state={state}>
      <span className="ds-mobile-list-item__top">
        <strong>{title}</strong>
        {status}
      </span>
      {subtitle ? (
        <span
          className={mergeClassNames(
            'ds-mobile-list-item__subtitle',
            subtitleTone === 'muted' && 'ds-mobile-list-item__subtitle--muted',
          )}
        >
          {subtitle}
        </span>
      ) : null}
      {meta
        ?.filter((line): line is string => Boolean(line))
        .map((line) => (
          <span className="ds-mobile-list-item__meta" key={line}>
            {line}
          </span>
        ))}
      {warning ? <span className="ds-mobile-list-item__warning">⚠ {warning}</span> : null}
      <ChevronRight aria-hidden="true" className="ds-mobile-list-item__chevron" />
    </Link>
  )
}
